export default "__VITE_ASSET__CtCvEEyI__"